// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__23b0M","footer":"ModalError_footer__3sOGd"};